import React from "react";

export const PrevTerm5 = () => {
    return (
        <div className="previous-terms-content">
            {/* 2. 스마트올 중학_개인정보 처리방침 개정(240326) */}
            <h1>개인정보 처리방침</h1>
            <h2>개인정보 처리방침</h2>
            <p>
                (주) 웅진씽크빅(이하 “회사”라 한다)이 운영하는 웅진 스마트올중학은 「정보통신망법」 및
                「개인정보보호법」 을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을
                다하고 있습니다. 스마트올중학의 개인정보 처리방침을 통하여 고객님께서 제공하시는 개인정보를 어떠한
                용도와 방식으로 이 용하고 있으며, 개인정보보호를 위해 어떠한 조치를 취하고 있는지 알려드립니다. 본
                방침은 2024년 4월 3일부터 시행되며, 회사는 이를 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여
                공지하겠습니다.
            </p>
            <div>
                <h2>1. 수집하는 개인정보의 처리에 관한 사항</h2>
                <h3>1) 개인 정보의 처리 목적, 항목, 보유 및 이용기간</h3>
                <p>- 회사는 서비스 이용 시 고객으로부터 아래와 같은 개인 정보를 처리하고 있습니다.</p>
                <table>
                    <colgroup>
                        <col style={{ width: "25%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "20%" }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>목적</th>
                            <th>구분</th>
                            <th>항목</th>
                            <th>보유 및 이용기간</th>
                        </tr>
                        <tr>
                            <td>계약의 체결·이행·관리·배송, 만14세 미만 아동 본인 확인, 현금영수증 발급 </td>
                            <td>필수</td>
                            <td>
                                이름, 성별, 생년월일, 주소, 연락처, E-mail, 자녀정보(이름, 생년월일, 학교명, 학년),
                                녹취자료
                            </td>
                            <td rowSpan={3}>계약종료 후 1년 (단, 법령에 특별한 규정이 있을 경우 관련 법령에 따름)</td>
                        </tr>
                        <tr>
                            <td>월 회비 정산·청구·수납·추심 </td>
                            <td>필수</td>
                            <td>
                                결제정보(결제일, 은행명, 예금주, 계좌번호 또는 카드명, 소유주, 카드유효기간, 카드번호)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                고지사항 전달, 계약 이행을 위한 연락, 민원 등 고객 상담 처리, 서비스 만족도 조 사, 고객
                                맞춤형 서비스
                            </td>
                            <td>필수</td>
                            <td>주소, 연락처, E- mail, 연령, 콘텐츠 사용이력</td>
                        </tr>
                        <tr>
                            <td>상담신청</td>
                            <td>필수</td>
                            <td>학부모명, 연락처, 자녀정보(학년)</td>
                            <td>계약종료 후 1년</td>
                        </tr>
                        <tr>
                            <td>수강권 구매하기</td>
                            <td>필수</td>
                            <td>
                                부모정보(이름, 연락처, 생년월일, 성별, 주소, E-mail) 자녀정보(이름, 연락처, 생년월일,
                                학년, 주소, E-mail) 결제정보(결제일, 은행명, 카드명, 소유주, 생년월일, 카드유효기간,
                                카드번호)
                            </td>
                            <td>계약종료 후 1년 (단, 법령에 특별한 규정이 있을 경우 관련 법령에 따름)</td>
                        </tr>
                        <tr>
                            <td>학습상담 신청</td>
                            <td>필수</td>
                            <td>학부모명, 연락처, 자녀정보(학년)</td>
                            <td>계약종료 후 1년</td>
                        </tr>
                        <tr>
                            <td>문자를 통한 맞춤 서비스 제공</td>
                            <td>선택</td>
                            <td>이름, 연락처</td>
                            <td>계약종료 후 1년</td>
                        </tr>
                        <tr>
                            <td>신규서비스 개발, 서비스 이용 통계 및 설문</td>
                            <td>선택</td>
                            <td>이름, 성별, 생년월일, 연락처, 주소, E-mail, 자녀정보 (이름, 성별, 생년월일, 학년)</td>
                            <td>계약종료 후 1년</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    ※ 선택적 수집 · 이용에 대한 부분은 동의를 거부하시는 경우에도 스마트올 중학이 제공하는 서비스는 이용
                    하실 수 있습니다.
                </p>
            </div>
            <div>
                <h2>2. 만 14세 미만의 미성년자 보호</h2>
                <h3>
                    1) 만 14세 미만 아동(이하 '아동')이 제공한 개인정보로 인하여 아동 및 법정 대리인이 불이익을 입지
                    않도록 보호 조치를 취하고 있습니다.
                </h3>
                <h3>
                    2) 아동의 개인정보에 대하여 아래의 행위를 하는 경우에는 해당 아동의 법정대리인의 동의를 얻도록 하고
                    있습니다.
                </h3>
                <p>
                    - 아동의 서비스가입을 위한 개인정보 수집하거나 서비스 가입 시 고지한 범위 또는 이용약관에 명시한
                    범위를 넘어 아동의 개인정보를 이용하거나 제3자에게 제공하고자 하는 경우
                </p>

                <p>
                    - 아동의 개인정보를 제공받은 자가 개인정보를 제공받은 목적 외의 용도로 이용하거나 제3자에게 제공하는
                    경우
                </p>
                <h3>
                    3) 법정대리인의 동의를 얻기 위하여 법정대리인의 이름, 주민번호 등 필요한 최소한의 정보를 요구할 수
                    있습니다. 이 경우 개인정보의 수집 · 이용 또는 제공 목적 및 법정대리인의 동의가 필요합니다.
                </h3>
                <h3>
                    4) 법정대리인의 동의를 얻기 위하여 수집한 법정대리인의 개인정보를 해당 법정대리인의 동의 여부를 확인
                    하는 목적 외의 용도로 이용하거나 제3자에게 제공하지 않습니다.
                </h3>
            </div>
            <div>
                <h2>3. 개인정보 제3자 제공에 관한 사항</h2>
                <h3>
                    1) 회사는 이용자의 개인정보를 제 1 조(수집하는 개인정보 처리에 관한 사항)에서 명시한 범위 내에서만
                    처 리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보보호법」 제 17 조 및 제 18 조에 해당하는
                    경우에 만 개인정보를 제 3 자에게 제공합니다.
                </h3>
                <h3>2) 회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다</h3>
                <table>
                    <tbody>
                        <tr>
                            <th>제공받는 자 </th>
                            <th>제공 목적</th>
                            <th>제공하는 개인정보 항목</th>
                        </tr>
                        <tr>
                            <td>SKN(리포나) / MPGIO / 오션아이</td>
                            <td>A/S 및 리퍼비시</td>
                            <td>이름, 주소, 서비스 가입일</td>
                        </tr>
                        <tr>
                            <td>삼성전자판매 주식회사</td>
                            <td>판매실적 정산 </td>
                            <td>이름, 연락처, 상담신청일, 가입일, 가입상태 (유지/해지 등)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <h2>4. 개인정보 처리의 위탁에 관한 사항</h2>
                <h3>1) 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리 업무를 위탁하고 있습니다.</h3>
                <table>
                    <tbody>
                        <tr>
                            <th>위탁받는 자(수탁자)</th>
                            <th>위탁업무</th>
                        </tr>
                        <tr>
                            <td>주식회사 웅진</td>
                            <td>상담 처리 및 회원정보 계약 관리, 컨텐츠 사용 중 발생하는 각종 서비스 제공</td>
                        </tr>
                        <tr>
                            <td>나이스평가정보㈜</td>
                            <td>
                                계약체결 및 연체관리 목적을 위한 정보 조회 (신용등급, 연체정보, 대출정보, 식별정보),
                                채무불이행 등재
                            </td>
                        </tr>
                        <tr>
                            <td>코리아크레딧뷰로(KCB) 주식회사</td>
                            <td>휴대폰 본인인증</td>
                        </tr>
                        <tr>
                            <td>KLCNS</td>
                            <td>상담 처리</td>
                        </tr>
                        <tr>
                            <td> ㈜다우기술</td>
                            <td>문자메시지 전송, 카카오톡 알림톡 전송</td>
                        </tr>
                        <tr>
                            <td>금융결제원 / ㈜쿠콘 / 주식회사 케이에스넷 / 나이스정보통신㈜ / 한국정보통신</td>
                            <td>멤버십 월회비출금처리, ARS</td>
                        </tr>
                        <tr>
                            <td>나이스신용정보㈜</td>
                            <td>미납 및 멤버십 해지 채권에 대한 수납 관리 및 채권 추심</td>
                        </tr>
                        <tr>
                            <td>㈜북센</td>
                            <td>물품 배송</td>
                        </tr>
                        <tr>
                            <td>Amazon Web Services (AWS Kor) </td>
                            <td>클라우드 IT인프라 제공</td>
                        </tr>
                    </tbody>
                </table>
                <h3>
                    2) 회사는 위탁계약 체결 시 「개인정보보호법」 제 26 조에 따라 위탁업무 수행목적 외 개인정보
                    처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한
                    사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                </h3>
                <h3>
                    3) 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보처리방침을 통하여 공개하도록
                    하겠습니다
                </h3>
            </div>
            <div>
                <h2>5. 개인정보의 파기</h2>
                <h3>
                    1) 회사는 원칙적으로 고객님의 삭제요청, 개인정보 이용목적 달성, 개인정보 보유 및 이용기간의 경과 후
                    에는 해당 개인정보를 지체없이 파기합니다. 단, 고객님의 개인정보 보유기간에 대해 별도의 동의를 얻은
                    경우 또는 법령에서 일정 기간 보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를 별도의
                    데이터베이 스(DB)로 옮기거나 보관장소를 달리하여 안전하게 보관합니다.
                </h3>
                <h3> 2) 서비스 가입 시 고객님께 개인정보 보유기간에 대하여 동의를 얻은 경우는 아래와 같습니다</h3>
                <p>- 녹취자료는 계약기록 보존을 위하여 5년 간 보관 후 파기하고 있습니다</p>
                <p>- 그 외 관계 법령에 따른 보유 및 이용기간</p>
                <table>
                    <tbody>
                        <tr>
                            <th>보유내용</th>
                            <th>보유 및 이용기간</th>
                            <th>관계법령</th>
                        </tr>
                        <tr>
                            <td>계약 또는 청약철회 등의 공급기록</td>
                            <td>5년</td>
                            <td rowSpan={4}>전자상거래 등에서의 소비자보호에 관한 법률</td>
                        </tr>
                        <tr>
                            <td>대금결제, 재화 등의 공급기록</td>
                            <td>5년</td>
                        </tr>
                        <tr>
                            <td>소비자 불만 또는 분쟁처리에 관한 기록</td>
                            <td>3년</td>
                        </tr>
                        <tr>
                            <td>표시 · 광고에 관한 기록 </td>
                            <td>6개월</td>
                        </tr>
                    </tbody>
                </table>
                <h3>3) 파기 절차 </h3>
                <p>
                    - 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보
                    보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다
                </p>
                <p>- 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</p>
                <h3>4) 파기 방법 </h3>
                <p>- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. </p>
                <p>- 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. </p>
            </div>
            <div>
                <h2>6. 개인정보의 열람, 수정, 동의철회 등 정보주체의 권리 및 행사방법</h2>
                <h3>
                    1) 회사는 고객님의 개인정보에 대해 열람, 수정, 동의철회 등의 요구가 있을 시 지체 없이 이를
                    처리합니다. 따라서 고객님은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를
                    열람 하거나 수 정할 수 있으며 동의철회를 요청할 수도 있습니다
                </h3>
                <h3>
                    2) 이용자의 개인정보 조회, 수정을 위해서는 대표전화(1577-1500) 또는 개인정보관리자에게 서면이나 전화
                    를 통한 열람, 정정 또는 탈퇴 또한 가능합니다
                </h3>
                <h3>
                    3) 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우, 정정 완료 전까지 당해 개인정보를 이용 또는
                    제공하지 않습니다. 또한 잘못된 개인정보를 제3 자에게 이미 제공한 경우에는 정정·처리결과를 제3자에게
                    지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
                </h3>
                <h3>
                    4) 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 개인정보 보유기간에 명시
                    된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다. 단, 다음의
                    경우에는 요청을 제한 또는 거절할 수 있고, 회사는 이를 고객님께 지체 없이 고지합니다
                </h3>
                <p>- 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</p>
                <p>
                    - 다른 사람의 생명, 신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려
                    가 있는 경우
                </p>
                <p>
                    - 개인정보를 처리하지 아니하면 회원과 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우로
                    서 회원이 그 계약의 해지의사를 명확하게 밝히지 아니한 경우
                </p>
            </div>
            <div>
                <h2>7. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h2>
                <p>
                    회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 ‘쿠키
                    (cookie)’를 사용합니다.
                </p>
                <h3>1) 쿠키(cookie)란?</h3>
                <p>
                    쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이
                    용자 컴퓨터의 하드디스크에 저장됩니다. 이후 이용자가 웹 사이트에 방문할 경우 웹 사이트 서버는 이용자
                    의 하드 디스크에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제
                    공하기 위해 이용됩니다.
                </p>
                <h3>2) 쿠키 사용 목적</h3>
                <p>
                    회원과 비회원의 접속 빈도나 방문 시간 등의 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종
                    이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스를 제공하기 위해 쿠키를
                    사용합니다.
                </p>
                <h3>3) 쿠키의 설치/운영 및 거부 </h3>
                <p>
                    이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 웹브라우저별 옵션 설정을 통해 모든 쿠키를 허용 또
                    는 거부하거나, 쿠키가 저장될 때마다 확인을 거치도록 할 수 있습니다. 다만, 쿠키의 저장을 거부할
                    경우에 는 로그인이 필요한 회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다.
                </p>
                <p>쿠키 설치 허용여부를 지정하는 방법</p>
                <p>- Internet Explorer: [도구] &gt; [인터넷 옵션] &gt; [개인정보] 탭&gt; [고급] 설정</p>
                <p>- Microsoft Edge: [설정] &gt; [쿠키 및 사이트 권한] 설정</p>
                <p>- Chrome: [설정] &gt; [개인정보 및 보안] &gt; [쿠키 및 기타 사이트 데이터] 설정</p>
            </div>
            <div>
                <h2>8. 개인정보 안전성 확보 조치에 관한 사항</h2>
                <h3>
                    1) 회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록
                    안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.
                </h3>
                <p>
                    - 개인정보처리시스템 등의 접근 권한 관리, 침입 탐지 및 차단 시스템 가동, 파일 및 전송데이터 암호화
                </p>
                <p>- 컴퓨터 바이러스에 의한 피해 방지를 위한 자동 Update 백신 이용</p>
                <h3>2) 회사는 고객님의 개인정보보호를 위해 다음과 같은 관리적 조치를 취하고 있습니다. </h3>
                <p>
                    - 개인정보를 취급하는 직원을 최소한으로 줄이고, 정기 또는 수시 교육을 통해 개인정보보호정책을 준수하
                    도록 강조하고 있습니다.
                </p>
                <p>
                    - 모든 임직원 및 계약직 사원에게 보안서약서를 제출하게 함으로 사람에 의한 정보유출을 사전에 방지하고
                    있습니다.
                </p>
                <p>
                    - 위반 내용이 확인되는 경우 이를 시정 또는 개선하며 기타 필요한 조치를 취하기 위한 내부절차를 마련하
                    고 있습니다.
                </p>
            </div>
            <div>
                <h2>9. 개인정보에 관한 민원서비스</h2>
                <h3>
                    1) 스마트올은 회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 개인정
                    보보호책임자를 지정하고 있습니다.
                </h3>
                <h3>
                    2) 정보주체는 「개인정보 보호법」 제 35 조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수
                    있습니다.
                </h3>
                <table>
                    <tbody>
                        <tr>
                            <th>구분</th>
                            <th>개인정보보책임자</th>
                            <th>개인정보관리자</th>
                            <th>고객만족센터</th>
                        </tr>
                        <tr>
                            <td>소속</td>
                            <td>웅진씽크빅 경영지원실</td>
                            <td>웅진씽크빅 정보보호팀</td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <td>직위</td>
                            <td>실장</td>
                            <td>팀장</td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <td>이름</td>
                            <td>이수종</td>
                            <td>안원필</td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <td>연락처</td>
                            <td colSpan={3}>1577-1500</td>
                        </tr>
                    </tbody>
                </table>
                <h3>
                    3) 스마트올의 서비스를 이용하며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리자 혹은
                    담당부서로 신고할 수 있고, 스마트올은 고객의 신고사항에 대해 신속하고 충분한 조치를 취할 것입니다.
                </h3>
                <h3>4) 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다</h3>
                <p>- 대검찰청 www.spo.go.kr ☎ 국번없이 1301</p>
                <p>- 경찰청 ecrm.cyber.go.kr ☎ 국번없이 182</p>
                <p>- 개인정보침해신고센터 privacy.kisa.or.kr ☎ 국번없이 118 </p>
                <p>- 개인정보 분쟁조정위원회 www.kopico.go.kr ☎ 국번없이 1833-6972</p>
            </div>
            <div>
                <h2>10. 고지의 의무</h2>
                <p>현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 고지할 것입니다.</p>
            </div>
            <div>
                <h2>11. 개인정보 처리방침의 변경에 관한 사항</h2>
                <p>이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</p>
                <p>- 2022. 11. 09 ~ 2024. 04. 02 적용</p>
                <p>- 2021. 07. 21 ~ 2022. 11. 08 적용</p>
                <p>- 2021. 06. 01 ~ 2021. 07. 20 적용</p>
                <p>- 2020. 12. 01 ~ 2021. 05. 31 적용</p>
            </div>
        </div>
    );
};
